import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { config } from '../services/api';

function AboutSection() {
  const [aboutData, setAboutData] = useState({
    homepage_title: 'Welcome to Delta X',
    homepage_short_description: 'We are a leading organization providing innovative solutions.'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/api/about_us/1/`);
        setAboutData(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching about data:', error);
        setLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  if (loading) {
    return (
      <Row className="text-center mb-5">
        <Col>
          <h2>Loading...</h2>
        </Col>
      </Row>
    );
  }

  return (
    <Row className="text-center mb-5">
      <Col>
        <h2>{aboutData.homepage_title}</h2>
        <p className="lead">
          {aboutData.homepage_short_description}
        </p>
      </Col>
    </Row>
  );
}

export default AboutSection;